import React, { useRef, useEffect } from 'react';

const ProjectWrapper = ({ 
  wrapperClass,
  position,
  dimensions,
  hoverConfig,
  textConfig,
  linkTo,
  children 
}) => {
  const containerRef = useRef(null);
  const effectRef = useRef(null);

  useEffect(() => {
    if (containerRef.current && window.hoverEffect) {
      console.log('Initializing hover effect for', wrapperClass);
      
      const timer = setTimeout(() => {
        try {
          // Nettoyer l'effet précédent
          if (effectRef.current && containerRef.current.childNodes.length > 0) {
            const canvas = containerRef.current.querySelector('canvas');
            if (canvas) {
              canvas.remove();
            }
          }
          
          // Créer le nouvel effet SANS hover automatique
          effectRef.current = new window.hoverEffect({
            parent: containerRef.current,
            intensity: hoverConfig.intensity,
            image1: hoverConfig.image1,
            image2: hoverConfig.image2,
            displacementImage: hoverConfig.displacementImage,
            hover: false  // Désactiver le hover automatique
          });
          
          console.log('Hover effect created successfully for', wrapperClass);
        } catch (error) {
          console.error('Error creating hover effect for', wrapperClass, error);
        }
      }, 100);
      
      return () => {
        clearTimeout(timer);
        if (containerRef.current) {
          const canvas = containerRef.current.querySelector('canvas');
          if (canvas) {
            canvas.remove();
          }
        }
      };
    }
  }, [hoverConfig, wrapperClass]);

  // Gestionnaire de hover manuel au niveau du wrapper parent
  const handleMouseEnter = () => {
    if (effectRef.current && effectRef.current.next) {
      effectRef.current.next();
    }
  };

  const handleMouseLeave = () => {
    if (effectRef.current && effectRef.current.previous) {
      effectRef.current.previous();
    }
  };

  const wrapperStyle = {
    position: 'absolute',
    width: `${dimensions.width}px`,
    height: `${dimensions.height}px`,
    left: `${position.left}px`,
    top: `${position.top}px`,
    zIndex: position.zIndex || 'auto',
    transition: 'all 0.8s ease',
    cursor: 'pointer'
  };

  const imageContainerStyle = {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    overflow: 'hidden'
  };

  return (
    <a href={linkTo} style={{ position: 'absolute', textDecoration: 'none' }}>
      <div 
        className={`project-wrapper ${wrapperClass}`} 
        style={wrapperStyle}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        {/* Container pour l'effet hover - PLEINE TAILLE */}
        <div 
          ref={containerRef} 
          className="hover-image-container"
          style={imageContainerStyle}
        />
        
        {/* Bloc de texte avec positionnement spécifique */}
        <div 
          className={`hover-text-bloc ${textConfig.blocClass}`}
          style={{
            position: 'absolute',
            width: '260px',
            padding: '5%',
            borderRadius: '25px',
            ...textConfig.blocStyle
          }}
        >
          <p 
            className={`hover-title ${textConfig.titleClass}`}
            style={{
              fontFamily: '"Roboto", sans-serif',
              fontSize: '2.3rem',
              fontWeight: 'normal',
              color: 'white',
              letterSpacing: '0.4rem',
              textTransform: 'uppercase',
              opacity: 0.7,
              transition: 'all 0.8s ease',
              ...textConfig.titleStyle
            }}
          >
            {textConfig.title}
          </p>
          
          {textConfig.texts.map((text, index) => (
            <p 
              key={index}
              className={`hover-text ${textConfig.textClass}`}
              style={{
                fontFamily: '"Roboto", sans-serif',
                fontSize: '1.6rem',
                fontWeight: textConfig.textWeight || 200,
                color: textConfig.textColor || 'white',
                letterSpacing: '0.1rem',
                opacity: 0,
                marginBottom: '6px',
                transition: 'all 0.8s ease',
                width: textConfig.textWidth || '200px',
                textAlign: textConfig.textAlign || 'left',
                ...textConfig.textStyle
              }}
            >
              {text}
            </p>
          ))}
        </div>
        
        {children}
      </div>
    </a>
  );
};

export default ProjectWrapper;